import { z } from 'zod'
import { FeedbackThumb } from '@/chat-common/schemas/feedback-schema'

export const AgentV2TurnFeedbackSchema = z.object({
  turn_id: z.string().uuid(),
  thumb_rating: z.nativeEnum(FeedbackThumb),
  thumb_text: z.string().nullable(),
  thumb_reasons: z.array(z.string()).nullable(),
})

export type AgentV2TurnFeedback = z.infer<typeof AgentV2TurnFeedbackSchema>
